import React, { useEffect, useState, useCallback } from "react";
// import { ReactComponent as BackIcon } from "../../assets/svgs/back-square.svg";
// import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { useNavigate } from "react-router-dom";
import { getApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";
import toast from "react-hot-toast";
import { SearchBar } from "../../components/Elements/Search/SearchBar";
import { QuestionForm } from "./components/questionForm";
import AddModifyButton from "./components/AddModifyButton";
import QuestionDialog from "../StandardForms/DialogBoxes/QuestionDialog";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";
const Questionss = ({ formId, sectionId, approved, subSectionId }) => {
  const [questionsData, setQuestionsData] = useState([]);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
 const [popup, setPopup] = useState({
    open: false,
    title: "",
    message: "",
  });

  //add modify button click handler
  const handleAddModifyClick = () => {
    if (approved === true) {
      setPopup({
        open: true,
        title: "Form Already Approved",
        message:
          "This Standard Form has already been approved and is currently locked for editing. To make modifications, the manager must unlock it or change its status to Draft first.",
      });
      return;
    }
    setOpenCreateDialog(true);
  };
//popup auto close 
  useEffect(() => {
      if (popup.open) {
        const timer = setTimeout(() => {
          setPopup((prev) => ({
            ...prev,
            open: false,
          }));
        }, 5000);
  
        return () => clearTimeout(timer);
      }
    }, [popup.open]);


  const navigate = useNavigate();

  const fetchQuestions = useCallback(async () => {
    if (!subSectionId) return;

    try {
      setLoading(true);
      const response = await getApi({
        apiUrl: API_URLS.GET_STANDARD_SUBSECTIONQUESTIONS_BY_ID(
          formId,
          sectionId,
          subSectionId,
          searchTerm
        )
      });

      if (response.success) {
        console.log("Questions (raw response)rrssssaasachna:", response.data);
        setQuestionsData(response?.data?.divisions ?? []);
        setTotalQuestions(response?.data?.totalDivisionQuestion ?? 0);
      } else {
        setQuestionsData([]);
        setTotalQuestions(0);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
      toast.error("Failed to fetch questions");
    } finally {
      setLoading(false);
    }
  }, [subSectionId, searchTerm, formId, sectionId]);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  return (
    <div style={{ backgroundColor: "#fff" }} className="h-screen">
      <div className="rounded-lg border border-[#3BA2B959] shadow-md pt-5">
        <div className="flex justify-between mx-8">
          <div className="flex gap-4 pl-3">
            <p className="px-8  h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light">
              TOTAL QUESTION: {totalQuestions ?? questionsData.length ?? 0}
            </p>

            <SearchBar
              width="300px"
              onSearch={(value) => setSearchTerm(value)}
            />
          </div>
          <div className="flex gap-5">
            <AddModifyButton onClick={handleAddModifyClick} />
          </div>
        </div>

        <div className="mx-20 shadow-[0_0_16px_0_#3BA2B91F] mt-6 rounded-none pb-10">
          {loading ? (
            <p className="p-10">Loading...</p>
          ) : questionsData.length > 0 ? (
            <QuestionForm 
              formId={formId}
              sectionId={sectionId}
              subSectionId={subSectionId}
              questions={questionsData} 
            />
          ) : (
            <p className="border pl-10 py-6">No questions found.</p>
          )}
        </div>
      </div>
      {openCreateDialog && (
        <QuestionDialog
          onOpen={openCreateDialog}
          formId={formId}
          onClose={() => setOpenCreateDialog(false)}
        />
      )}


         {popup.open && (
              <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20">
                <PopupCard
                  title={popup.title}
                  type="error"
                  message={popup.message}
                  onOpen={popup.open}
                  onClose={() => setPopup((prev) => ({ ...prev, open: false }))}
                />
              </div>
            )}
    </div>
  );
};

export default Questionss;
